import script from "./PlayLottieFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlayLottieFile.vue?vue&type=script&lang=ts&setup=true"

import "./PlayLottieFile.vue?vue&type=style&index=0&id=1d204fa5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d204fa5"]])

export default __exports__